export default __webpack_public_path__ + "static/modal-header-image-89286e084d9371540efdc50756f9770f.jpg";